import validateQuantityDiscount from './validateQuantityDiscount';
const getQuantityDiscount = product => {
    // Asi lo tiene hecho el loco, se podria simplificar pero paja
    if (validateQuantityDiscount(product)) {
        let bonificacionFarmacia = product.precio1 * (1 - product.po1 / 100);
        return ((1 - bonificacionFarmacia / product.precio2) * 100).toFixed(2);
    }
};

export default getQuantityDiscount;
